import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';
import Typography, { headlinePropTypes } from 'Components/Typography';

export default class Lacon extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    children: PropTypes.node,
    dark: PropTypes.bool,
    e2e: PropTypes.string,
    headline: PropTypes.shape(headlinePropTypes),
  };

  renderContent(children, placeholder) {
    if (children) {
      return children;
    }

    if (placeholder) {
      return <div className={styles.placeholder}>{placeholder}</div>;
    }
  }

  render() {
    const { headline, dark, label, e2e, placeholder, children } = this.props;
    const className = classNames(styles.lacon, {
      [styles.dark]: dark,
    });

    return (
      <div className={className} data-e2e={e2e}>
        <Typography.Headline
          level="h5"
          className={styles.headline}
          value={label}
          forceUppercase={true}
          {...headline}
        />
        {this.renderContent(children, placeholder)}
      </div>
    );
  }
}
